export default {
  'BOTTOMS': 'Bottoms',
  'TOPS': 'Tops',
  'FULL COVERAGE': 'Full Coverage',
  '1-PIECE': '1-Piece',
  'SKIRT BOTTOMS': 'Skirt Bottoms',
  'MATERNITY BOTTOMS': 'Maternity Bottoms',
  'RASH GUARDS': 'Rash Guards',
  'BOARDIES': 'Boardies',
  'TRUNKS': 'Trunks',
  'SHORTS': 'Shorts',
  'SHORTIES': 'Shorties',
  'SPLASHERS': 'Splashers',
}
